import { ErrorsCallback, SuccessCallback } from "./alertService"
import Auth from "auth"
import ConfigHost from "./ConfigHost"
var Authorization = Auth.getUserToken()

// const headers = {
//   Authorization: Auth.getUserToken(),
//   "Content-Type": "application/x-www-form-urlencoded"
// }
var headers = new Headers();
// headers.append('Content-Type', 'application/json; charset=utf-8');
headers.append('Authorization', Authorization);

export const APIGet = (URL, callback) => {
  return fetch(ConfigHost.HOST_API + URL, {
    method: "GET",
    headers: headers
  }).then(response => { if (callback) response.json() })
}
export const API = async (
  method,
  URL,
  JsonDatas,
  callBackSuccess,
  callBackError
) => {
  var formData = new FormData()

  for (var key in JsonDatas) {
    var firstStrKey = key.substr(0, 1)
    firstStrKey = firstStrKey
    // firstStrKey = firstStrKey.toUpperCase()
    var bodyKey = key.substr(1)
    const newKey = firstStrKey + bodyKey
    formData.append(newKey, JsonDatas[key])
  }
  var dataForSend = {
    method: method,
    headers: headers
  }
  if (method !== "GET") {
    dataForSend.body = formData
    // dataForSend.body = JSON.stringify(JsonDatas)
  }
  fetch(ConfigHost.HOST_API + URL, dataForSend)
    .then(response => {
      // console.log("API Response >>> ", response);
      if (response.status === 200) {
        return response.json()
      }
    })
    .then(responseData => {
      if (responseData && responseData.success) {
        APIMiddlewareSuccess(responseData, callBackSuccess)
      } else {
        APIMiddlewareErrors(responseData, callBackError)
      }
    })
    .catch(error => {
      console.log("API error >>> ", error);
      APIMiddlewareErrors(error, callBackError)
    })
}

function APIMiddlewareSuccess(datas, callBackSuccess) {
  console.log("API Response Success >>> ", datas);
  if (datas.middlewareAlart !== undefined && datas.middlewareAlart && datas.message !== undefined) {
    SuccessCallback(datas.message, 0, () => {
      callBackSuccess(datas)
    })
  } else {
    callBackSuccess(datas)
  }
}
function APIMiddlewareErrors(responseData, callBackError) {

  console.log("API Response Errors >>> ", responseData);
  var statusShowErrors = true
  var textError = "\n"
  if (responseData.errors) {
    responseData.errors.forEach(element => {
      switch (element.Code) {
        case 100:
        case 99:
        case 97:
        case 96:
        case 95:
          Auth.destroyAuthentication()
          statusShowErrors = false
          ErrorsCallback(responseData.message, () => {
            window.location.reload()
          })

          return
        default:
          break
      }
      // console.log(element)

      textError += element.message + "\n"
    })
  }

  if (statusShowErrors) {
    ErrorsCallback(
      responseData.message + " " + textError,
      null
    )
  }

  if (callBackError) {
    callBackError(responseData)
    return
  }

}
